

const dev = {
    EMAILJS_PUBLIC_TOKEN: process.env.REACT_APP_EMAILJS_PUBLIC_TOKEN
};

const prod = {
    EMAILJS_PUBLIC_TOKEN: process.env.REACT_APP_EMAILJS_PUBLIC_TOKEN
};

const config = process.env.REACT_APP_NODE_ENV === 'production' ? prod : dev;

export default config;